export default "__VITE_ASSET__DUnvlZ7r__"